// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_kassaapis__Buhta_kassa_v1_types from "./buhta_kassa_v1_types.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement from "./buhta_kassa_v1alpha1_money_placement.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetMoneyPlacementRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_money_placement_service.ml",
  823,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const GetMoneyPlacementResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_money_placement_service.ml",
  889,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ListMoneyPlacementsRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_money_placement_service.ml",
  950,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ListMoneyPlacementsResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_money_placement_service.ml",
  1013,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const CreateMoneyPlacementRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_money_placement_service.ml",
  1105,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "MoneyPlacementData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const CreateMoneyPlacementResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_money_placement_service.ml",
  1232,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.kassa.v1alpha1.GetMoneyPlacementRequest";
}

function make(kkm_idOpt, idOpt, expandOpt, param) {
  const kkm_id = kkm_idOpt !== undefined ? kkm_idOpt : 0;
  const id = idOpt !== undefined ? idOpt : "";
  const expand = expandOpt !== undefined ? expandOpt : /* [] */ 0;
  return {
    kkm_id: kkm_id,
    id: id,
    expand: expand
  };
}

const merge_kkm_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "kkm_id",
    "kkmId"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    3,
    "expand",
    "expand"
  ],
  Ocaml_protoc_plugin__Spec.string,
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge(t1, t2) {
  return {
    kkm_id: Curry._2(merge_kkm_id, t1.kkm_id, t2.kkm_id),
    id: Curry._2(merge_id, t1.id, t2.id),
    expand: Curry._2(merge_expand, t1.expand, t2.expand)
  };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "kkm_id",
      "kkmId"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      3,
      "expand",
      "expand"
    ],
    Ocaml_protoc_plugin__Spec.string,
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p(writer, param) {
  Curry._4(serialize, writer, param.kkm_id, param.id, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(kkm_id, id, expand) {
  return {
    kkm_id: kkm_id,
    id: id,
    expand: expand
  };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetMoneyPlacementRequest", spec(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.kkm_id, param.id, param.expand);
  };
}

function constructor$1(kkm_id, id, expand) {
  return {
    kkm_id: kkm_id,
    id: id,
    expand: expand
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetMoneyPlacementRequest", spec(undefined), constructor$1);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetMoneyPlacementRequest, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

function name$1(param) {
  return ".buhta.kassa.v1alpha1.GetMoneyPlacementResponse";
}

function make$1(money_placement, param) {
  return {
    money_placement: money_placement
  };
}

const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement.Buhta.Kassa.V1alpha1.MoneyPlacement;

const merge_money_placement = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "money_placement",
    "moneyPlacement"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let.name,
    make: $$let.make,
    from_proto: $$let.from_proto,
    from_proto_exn: $$let.from_proto_exn,
    to_proto: $$let.to_proto,
    to_proto$p: $$let.to_proto$p,
    merge: $$let.merge,
    to_json: $$let.to_json,
    from_json_exn: $$let.from_json_exn,
    from_json: $$let.from_json
  })
]));

function merge$1(t1, t2) {
  return {
    money_placement: Curry._2(merge_money_placement, t1.money_placement, t2.money_placement)
  };
}

function spec$1(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement.Buhta.Kassa.V1alpha1.MoneyPlacement;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "money_placement",
      "moneyPlacement"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
});

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.money_placement);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(money_placement) {
  return {
    money_placement: money_placement
  };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
});

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$1, writer);
  });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetMoneyPlacementResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.money_placement);
  };
}

function constructor$3(money_placement) {
  return {
    money_placement: money_placement
  };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetMoneyPlacementResponse", spec$1(undefined), constructor$3);
});

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$1, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetMoneyPlacementResponse, {
  make: make$1,
  to_proto: to_proto$1,
  from_proto: from_proto$1,
  to_json: to_json$1,
  from_json: from_json$1,
  name: name$1,
  merge: merge$1,
  to_proto$p: to_proto$p$1,
  from_proto_exn: from_proto_exn$1,
  from_json_exn: from_json_exn$1
});

function name$2(param) {
  return ".buhta.kassa.v1alpha1.ListMoneyPlacementsRequest";
}

function make$2(kkm_idOpt, grid, param) {
  const kkm_id = kkm_idOpt !== undefined ? kkm_idOpt : 0;
  return {
    kkm_id: kkm_id,
    grid: grid
  };
}

const merge_kkm_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "kkm_id",
    "kkmId"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "grid",
    "grid"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$1.name,
    make: $$let$1.make,
    from_proto: $$let$1.from_proto,
    from_proto_exn: $$let$1.from_proto_exn,
    to_proto: $$let$1.to_proto,
    to_proto$p: $$let$1.to_proto$p,
    merge: $$let$1.merge,
    to_json: $$let$1.to_json,
    from_json_exn: $$let$1.from_json_exn,
    from_json: $$let$1.from_json
  })
]));

function merge$2(t1, t2) {
  return {
    kkm_id: Curry._2(merge_kkm_id$1, t1.kkm_id, t2.kkm_id),
    grid: Curry._2(merge_grid, t1.grid, t2.grid)
  };
}

function spec$2(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "kkm_id",
      "kkmId"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "grid",
      "grid"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
});

function to_proto$p$2(writer, param) {
  Curry._3(serialize$2, writer, param.kkm_id, param.grid);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(kkm_id, grid) {
  return {
    kkm_id: kkm_id,
    grid: grid
  };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
});

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$2, writer);
  });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ListMoneyPlacementsRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.kkm_id, param.grid);
  };
}

function constructor$5(kkm_id, grid) {
  return {
    kkm_id: kkm_id,
    grid: grid
  };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ListMoneyPlacementsRequest", spec$2(undefined), constructor$5);
});

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$2, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ListMoneyPlacementsRequest, {
  make: make$2,
  to_proto: to_proto$2,
  from_proto: from_proto$2,
  to_json: to_json$2,
  from_json: from_json$2,
  name: name$2,
  merge: merge$2,
  to_proto$p: to_proto$p$2,
  from_proto_exn: from_proto_exn$2,
  from_json_exn: from_json_exn$2
});

function name$3(param) {
  return ".buhta.kassa.v1alpha1.ListMoneyPlacementsResponse";
}

function make$3(money_placementsOpt, param) {
  const money_placements = money_placementsOpt !== undefined ? money_placementsOpt : /* [] */ 0;
  return {
    money_placements: money_placements
  };
}

const $$let$2 = Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement.Buhta.Kassa.V1alpha1.MoneyPlacement;

const merge_money_placements = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    1,
    "money_placements",
    "moneyPlacements"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$2.name,
    make: $$let$2.make,
    from_proto: $$let$2.from_proto,
    from_proto_exn: $$let$2.from_proto_exn,
    to_proto: $$let$2.to_proto,
    to_proto$p: $$let$2.to_proto$p,
    merge: $$let$2.merge,
    to_json: $$let$2.to_json,
    from_json_exn: $$let$2.from_json_exn,
    from_json: $$let$2.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$3(t1, t2) {
  return {
    money_placements: Curry._2(merge_money_placements, t1.money_placements, t2.money_placements)
  };
}

function spec$3(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement.Buhta.Kassa.V1alpha1.MoneyPlacement;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      1,
      "money_placements",
      "moneyPlacements"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
});

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.money_placements);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(money_placements) {
  return {
    money_placements: money_placements
  };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
});

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$3, writer);
  });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ListMoneyPlacementsResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.money_placements);
  };
}

function constructor$7(money_placements) {
  return {
    money_placements: money_placements
  };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ListMoneyPlacementsResponse", spec$3(undefined), constructor$7);
});

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$3, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ListMoneyPlacementsResponse, {
  make: make$3,
  to_proto: to_proto$3,
  from_proto: from_proto$3,
  to_json: to_json$3,
  from_json: from_json$3,
  name: name$3,
  merge: merge$3,
  to_proto$p: to_proto$p$3,
  from_proto_exn: from_proto_exn$3,
  from_json_exn: from_json_exn$3
});

const MoneyPlacementData = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_money_placement_service.ml",
  1137,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$4(param) {
  return ".buhta.kassa.v1alpha1.CreateMoneyPlacementRequest.MoneyPlacementData";
}

function make$4(placement_typeOpt, amountOpt, param) {
  const placement_type = placement_typeOpt !== undefined ? placement_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.MoneyPlacementType.from_int_exn, 0);
  const amount = amountOpt !== undefined ? amountOpt : "";
  return {
    placement_type: placement_type,
    amount: amount
  };
}

const merge_placement_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "placement_type",
    "placementType"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.MoneyPlacementType),
  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.MoneyPlacementType.from_int_exn, 0)
]));

const merge_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "amount",
    "amount"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$4(t1, t2) {
  return {
    placement_type: Curry._2(merge_placement_type, t1.placement_type, t2.placement_type),
    amount: Curry._2(merge_amount, t1.amount, t2.amount)
  };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "placement_type",
      "placementType"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.MoneyPlacementType),
    Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.MoneyPlacementType.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "amount",
      "amount"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
});

function to_proto$p$4(writer, param) {
  Curry._3(serialize$4, writer, param.placement_type, param.amount);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(placement_type, amount) {
  return {
    placement_type: placement_type,
    amount: amount
  };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
});

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$4, writer);
  });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CreateMoneyPlacementRequest.MoneyPlacementData", spec$4(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.placement_type, param.amount);
  };
}

function constructor$9(placement_type, amount) {
  return {
    placement_type: placement_type,
    amount: amount
  };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CreateMoneyPlacementRequest.MoneyPlacementData", spec$4(undefined), constructor$9);
});

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$4, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, MoneyPlacementData, {
  make: make$4,
  to_proto: to_proto$4,
  from_proto: from_proto$4,
  to_json: to_json$4,
  from_json: from_json$4,
  name: name$4,
  merge: merge$4,
  to_proto$p: to_proto$p$4,
  from_proto_exn: from_proto_exn$4,
  from_json_exn: from_json_exn$4
});

function name$5(param) {
  return ".buhta.kassa.v1alpha1.CreateMoneyPlacementRequest";
}

function make$5(kkm_idOpt, money_placement, param) {
  const kkm_id = kkm_idOpt !== undefined ? kkm_idOpt : 0;
  return {
    kkm_id: kkm_id,
    money_placement: money_placement
  };
}

const merge_kkm_id$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "kkm_id",
    "kkmId"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_money_placement$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "money_placement",
    "moneyPlacement"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: MoneyPlacementData.name,
    make: MoneyPlacementData.make,
    from_proto: MoneyPlacementData.from_proto,
    from_proto_exn: MoneyPlacementData.from_proto_exn,
    to_proto: MoneyPlacementData.to_proto,
    to_proto$p: MoneyPlacementData.to_proto$p,
    merge: MoneyPlacementData.merge,
    to_json: MoneyPlacementData.to_json,
    from_json_exn: MoneyPlacementData.from_json_exn,
    from_json: MoneyPlacementData.from_json
  })
]));

function merge$5(t1, t2) {
  return {
    kkm_id: Curry._2(merge_kkm_id$2, t1.kkm_id, t2.kkm_id),
    money_placement: Curry._2(merge_money_placement$1, t1.money_placement, t2.money_placement)
  };
}

function spec$5(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "kkm_id",
      "kkmId"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "money_placement",
      "moneyPlacement"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: MoneyPlacementData.name,
      make: MoneyPlacementData.make,
      from_proto: MoneyPlacementData.from_proto,
      from_proto_exn: MoneyPlacementData.from_proto_exn,
      to_proto: MoneyPlacementData.to_proto,
      to_proto$p: MoneyPlacementData.to_proto$p,
      merge: MoneyPlacementData.merge,
      to_json: MoneyPlacementData.to_json,
      from_json_exn: MoneyPlacementData.from_json_exn,
      from_json: MoneyPlacementData.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
});

function to_proto$p$5(writer, param) {
  Curry._3(serialize$5, writer, param.kkm_id, param.money_placement);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(kkm_id, money_placement) {
  return {
    kkm_id: kkm_id,
    money_placement: money_placement
  };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
});

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$5, writer);
  });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CreateMoneyPlacementRequest", spec$5(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.kkm_id, param.money_placement);
  };
}

function constructor$11(kkm_id, money_placement) {
  return {
    kkm_id: kkm_id,
    money_placement: money_placement
  };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CreateMoneyPlacementRequest", spec$5(undefined), constructor$11);
});

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$5, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "MoneyPlacementData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, CreateMoneyPlacementRequest, {
  MoneyPlacementData: MoneyPlacementData,
  make: make$5,
  to_proto: to_proto$5,
  from_proto: from_proto$5,
  to_json: to_json$5,
  from_json: from_json$5,
  name: name$5,
  merge: merge$5,
  to_proto$p: to_proto$p$5,
  from_proto_exn: from_proto_exn$5,
  from_json_exn: from_json_exn$5
});

function name$6(param) {
  return ".buhta.kassa.v1alpha1.CreateMoneyPlacementResponse";
}

function make$6(money_placement, param) {
  return {
    money_placement: money_placement
  };
}

const $$let$3 = Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement.Buhta.Kassa.V1alpha1.MoneyPlacement;

const merge_money_placement$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "money_placement",
    "moneyPlacement"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$3.name,
    make: $$let$3.make,
    from_proto: $$let$3.from_proto,
    from_proto_exn: $$let$3.from_proto_exn,
    to_proto: $$let$3.to_proto,
    to_proto$p: $$let$3.to_proto$p,
    merge: $$let$3.merge,
    to_json: $$let$3.to_json,
    from_json_exn: $$let$3.from_json_exn,
    from_json: $$let$3.from_json
  })
]));

function merge$6(t1, t2) {
  return {
    money_placement: Curry._2(merge_money_placement$2, t1.money_placement, t2.money_placement)
  };
}

function spec$6(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_money_placement.Buhta.Kassa.V1alpha1.MoneyPlacement;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "money_placement",
      "moneyPlacement"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
});

function to_proto$p$6(writer, param) {
  Curry._2(serialize$6, writer, param.money_placement);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(money_placement) {
  return {
    money_placement: money_placement
  };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
});

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$6, writer);
  });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CreateMoneyPlacementResponse", spec$6(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.money_placement);
  };
}

function constructor$13(money_placement) {
  return {
    money_placement: money_placement
  };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CreateMoneyPlacementResponse", spec$6(undefined), constructor$13);
});

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$6, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, CreateMoneyPlacementResponse, {
  make: make$6,
  to_proto: to_proto$6,
  from_proto: from_proto$6,
  to_json: to_json$6,
  from_json: from_json$6,
  name: name$6,
  merge: merge$6,
  to_proto$p: to_proto$p$6,
  from_proto_exn: from_proto_exn$6,
  from_json_exn: from_json_exn$6
});

const getMoneyPlacement_0 = {
  name: GetMoneyPlacementRequest.name,
  make: GetMoneyPlacementRequest.make,
  from_proto: GetMoneyPlacementRequest.from_proto,
  from_proto_exn: GetMoneyPlacementRequest.from_proto_exn,
  to_proto: GetMoneyPlacementRequest.to_proto,
  to_proto$p: GetMoneyPlacementRequest.to_proto$p,
  merge: GetMoneyPlacementRequest.merge,
  to_json: GetMoneyPlacementRequest.to_json,
  from_json_exn: GetMoneyPlacementRequest.from_json_exn,
  from_json: GetMoneyPlacementRequest.from_json
};

const getMoneyPlacement_1 = {
  name: GetMoneyPlacementResponse.name,
  make: GetMoneyPlacementResponse.make,
  from_proto: GetMoneyPlacementResponse.from_proto,
  from_proto_exn: GetMoneyPlacementResponse.from_proto_exn,
  to_proto: GetMoneyPlacementResponse.to_proto,
  to_proto$p: GetMoneyPlacementResponse.to_proto$p,
  merge: GetMoneyPlacementResponse.merge,
  to_json: GetMoneyPlacementResponse.to_json,
  from_json_exn: GetMoneyPlacementResponse.from_json_exn,
  from_json: GetMoneyPlacementResponse.from_json
};

const getMoneyPlacement = [
  getMoneyPlacement_0,
  getMoneyPlacement_1
];

const listMoneyPlacements_0 = {
  name: ListMoneyPlacementsRequest.name,
  make: ListMoneyPlacementsRequest.make,
  from_proto: ListMoneyPlacementsRequest.from_proto,
  from_proto_exn: ListMoneyPlacementsRequest.from_proto_exn,
  to_proto: ListMoneyPlacementsRequest.to_proto,
  to_proto$p: ListMoneyPlacementsRequest.to_proto$p,
  merge: ListMoneyPlacementsRequest.merge,
  to_json: ListMoneyPlacementsRequest.to_json,
  from_json_exn: ListMoneyPlacementsRequest.from_json_exn,
  from_json: ListMoneyPlacementsRequest.from_json
};

const listMoneyPlacements_1 = {
  name: ListMoneyPlacementsResponse.name,
  make: ListMoneyPlacementsResponse.make,
  from_proto: ListMoneyPlacementsResponse.from_proto,
  from_proto_exn: ListMoneyPlacementsResponse.from_proto_exn,
  to_proto: ListMoneyPlacementsResponse.to_proto,
  to_proto$p: ListMoneyPlacementsResponse.to_proto$p,
  merge: ListMoneyPlacementsResponse.merge,
  to_json: ListMoneyPlacementsResponse.to_json,
  from_json_exn: ListMoneyPlacementsResponse.from_json_exn,
  from_json: ListMoneyPlacementsResponse.from_json
};

const listMoneyPlacements = [
  listMoneyPlacements_0,
  listMoneyPlacements_1
];

const createMoneyPlacement_0 = {
  name: CreateMoneyPlacementRequest.name,
  make: CreateMoneyPlacementRequest.make,
  from_proto: CreateMoneyPlacementRequest.from_proto,
  from_proto_exn: CreateMoneyPlacementRequest.from_proto_exn,
  to_proto: CreateMoneyPlacementRequest.to_proto,
  to_proto$p: CreateMoneyPlacementRequest.to_proto$p,
  merge: CreateMoneyPlacementRequest.merge,
  to_json: CreateMoneyPlacementRequest.to_json,
  from_json_exn: CreateMoneyPlacementRequest.from_json_exn,
  from_json: CreateMoneyPlacementRequest.from_json
};

const createMoneyPlacement_1 = {
  name: CreateMoneyPlacementResponse.name,
  make: CreateMoneyPlacementResponse.make,
  from_proto: CreateMoneyPlacementResponse.from_proto,
  from_proto_exn: CreateMoneyPlacementResponse.from_proto_exn,
  to_proto: CreateMoneyPlacementResponse.to_proto,
  to_proto$p: CreateMoneyPlacementResponse.to_proto$p,
  merge: CreateMoneyPlacementResponse.merge,
  to_json: CreateMoneyPlacementResponse.to_json,
  from_json_exn: CreateMoneyPlacementResponse.from_json_exn,
  from_json: CreateMoneyPlacementResponse.from_json
};

const createMoneyPlacement = [
  createMoneyPlacement_0,
  createMoneyPlacement_1
];

const V1alpha1_MoneyPlacementService = {
  GetMoneyPlacement: {
    name: "/buhta.kassa.v1alpha1.MoneyPlacementService/GetMoneyPlacement",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "MoneyPlacementService",
    method_name: "GetMoneyPlacement",
    $$Request: {
      name: GetMoneyPlacementRequest.name,
      make: GetMoneyPlacementRequest.make,
      from_proto: GetMoneyPlacementRequest.from_proto,
      from_proto_exn: GetMoneyPlacementRequest.from_proto_exn,
      to_proto: GetMoneyPlacementRequest.to_proto,
      to_proto$p: GetMoneyPlacementRequest.to_proto$p,
      merge: GetMoneyPlacementRequest.merge,
      to_json: GetMoneyPlacementRequest.to_json,
      from_json_exn: GetMoneyPlacementRequest.from_json_exn,
      from_json: GetMoneyPlacementRequest.from_json
    },
    $$Response: {
      name: GetMoneyPlacementResponse.name,
      make: GetMoneyPlacementResponse.make,
      from_proto: GetMoneyPlacementResponse.from_proto,
      from_proto_exn: GetMoneyPlacementResponse.from_proto_exn,
      to_proto: GetMoneyPlacementResponse.to_proto,
      to_proto$p: GetMoneyPlacementResponse.to_proto$p,
      merge: GetMoneyPlacementResponse.merge,
      to_json: GetMoneyPlacementResponse.to_json,
      from_json_exn: GetMoneyPlacementResponse.from_json_exn,
      from_json: GetMoneyPlacementResponse.from_json
    }
  },
  getMoneyPlacement: getMoneyPlacement,
  ListMoneyPlacements: {
    name: "/buhta.kassa.v1alpha1.MoneyPlacementService/ListMoneyPlacements",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "MoneyPlacementService",
    method_name: "ListMoneyPlacements",
    $$Request: {
      name: ListMoneyPlacementsRequest.name,
      make: ListMoneyPlacementsRequest.make,
      from_proto: ListMoneyPlacementsRequest.from_proto,
      from_proto_exn: ListMoneyPlacementsRequest.from_proto_exn,
      to_proto: ListMoneyPlacementsRequest.to_proto,
      to_proto$p: ListMoneyPlacementsRequest.to_proto$p,
      merge: ListMoneyPlacementsRequest.merge,
      to_json: ListMoneyPlacementsRequest.to_json,
      from_json_exn: ListMoneyPlacementsRequest.from_json_exn,
      from_json: ListMoneyPlacementsRequest.from_json
    },
    $$Response: {
      name: ListMoneyPlacementsResponse.name,
      make: ListMoneyPlacementsResponse.make,
      from_proto: ListMoneyPlacementsResponse.from_proto,
      from_proto_exn: ListMoneyPlacementsResponse.from_proto_exn,
      to_proto: ListMoneyPlacementsResponse.to_proto,
      to_proto$p: ListMoneyPlacementsResponse.to_proto$p,
      merge: ListMoneyPlacementsResponse.merge,
      to_json: ListMoneyPlacementsResponse.to_json,
      from_json_exn: ListMoneyPlacementsResponse.from_json_exn,
      from_json: ListMoneyPlacementsResponse.from_json
    }
  },
  listMoneyPlacements: listMoneyPlacements,
  CreateMoneyPlacement: {
    name: "/buhta.kassa.v1alpha1.MoneyPlacementService/CreateMoneyPlacement",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "MoneyPlacementService",
    method_name: "CreateMoneyPlacement",
    $$Request: {
      name: CreateMoneyPlacementRequest.name,
      make: CreateMoneyPlacementRequest.make,
      from_proto: CreateMoneyPlacementRequest.from_proto,
      from_proto_exn: CreateMoneyPlacementRequest.from_proto_exn,
      to_proto: CreateMoneyPlacementRequest.to_proto,
      to_proto$p: CreateMoneyPlacementRequest.to_proto$p,
      merge: CreateMoneyPlacementRequest.merge,
      to_json: CreateMoneyPlacementRequest.to_json,
      from_json_exn: CreateMoneyPlacementRequest.from_json_exn,
      from_json: CreateMoneyPlacementRequest.from_json
    },
    $$Response: {
      name: CreateMoneyPlacementResponse.name,
      make: CreateMoneyPlacementResponse.make,
      from_proto: CreateMoneyPlacementResponse.from_proto,
      from_proto_exn: CreateMoneyPlacementResponse.from_proto_exn,
      to_proto: CreateMoneyPlacementResponse.to_proto,
      to_proto$p: CreateMoneyPlacementResponse.to_proto$p,
      merge: CreateMoneyPlacementResponse.merge,
      to_json: CreateMoneyPlacementResponse.to_json,
      from_json_exn: CreateMoneyPlacementResponse.from_json_exn,
      from_json: CreateMoneyPlacementResponse.from_json
    }
  },
  createMoneyPlacement: createMoneyPlacement
};

const V1alpha1 = {
  GetMoneyPlacementRequest: GetMoneyPlacementRequest,
  GetMoneyPlacementResponse: GetMoneyPlacementResponse,
  ListMoneyPlacementsRequest: ListMoneyPlacementsRequest,
  ListMoneyPlacementsResponse: ListMoneyPlacementsResponse,
  CreateMoneyPlacementRequest: CreateMoneyPlacementRequest,
  CreateMoneyPlacementResponse: CreateMoneyPlacementResponse,
  MoneyPlacementService: V1alpha1_MoneyPlacementService
};

const Kassa = {
  V1alpha1: V1alpha1
};

const Buhta = {
  Kassa: Kassa
};

export {
  Imported$pmodules,
  Buhta,
}
/* GetMoneyPlacementRequest Not a pure module */
